module.exports = __webpack_public_path__ + "assets/assets/images/home/dentists-page-1.10d85378.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/home/dentists-page-1.svg
// module id = 218
// module chunks = 0